import { motion } from "framer-motion";
import styles from "./Page.module.scss";

type Props = {
  justifyContent?: string;
};

const variants = {
  hidden: { opacity: 0 },
  enter: { opacity: 1 },
  exit: { opacity: 0 },
};

export default function Page({
  children,
  justifyContent = "flex-start",
}: React.PropsWithChildren<Props>) {
  return (
    <motion.div
      className={styles.wrapper}
      initial="hidden"
      animate="enter"
      exit="exit"
      variants={variants}
      transition={{ duration: 0.2 }}
      style={
        { "--content-justification": justifyContent } as React.CSSProperties
      }
    >
      {children}
    </motion.div>
  );
}
